export var DefaultRewardsProgramName = 'Rewards';
export var DefaultRewardsProgramDescription = 'Apply the discounts you’ve earned to your online order!';
export var DefaultRewardsProgramEnrollment = 'Unlock exclusive discounts as you shop with us.';
// In Canada it is illegal to reference 'rewards'
export var CanadianDefaultRewardsProgramName = 'Member Club';
export var CanadianDefaultRewardsProgramDescription = 'View your member club wallet to apply towards your order!';
export var CanadianDefaultRewardsProgramEnrollment = 'Unlock member benefits as you shop with us.';
